import type { CommonTranslations } from "./commonTranslations.types"

const commonNlTranslations: CommonTranslations = {
  "validate": "Bevestig",
  "send": 'Stuur',
  "understand": "Ik begrijp het",
  "ok": "OK",
  "reload": "Vernieuw",
  "packageTransferIncluded": "Bij al onze pakketten is de transfer van uw aankomstpunt naar uw bestemming inbegrepen",
  "confirmation": {
    "confirmationErrorPopupPhone": "020 8200 600",
    "confirmationStatusReservationTitle": "Wat fijn je boeking is bevestigd!",
    "confirmationStatusReservationSubtitle1": "Je reis begint over",
    "confirmationStatusReservationSubtitle2": "dagen.",
    "confirmationReservation1": "Over enkele minuten ontvang je je boekingsbevestiging",
    "confirmationReservation2": "Je betaalt nu direct",
    "confirmationReservation3": "wat overeenkomt met",
    "confirmationReservation4": "% van de totale reissom.",
    "confirmationReservation5": "De restbetaling van",
    "confirmationReservation6": "dient voor",
    "confirmationReservation7": "betaald te zijn.",
    "confirmationReservation8": "Je vindt al deze informatie in je Travelski-account. Om in te loggen",
    "confirmationReservation9": "klik hier",
    "confirmationReservation10": ".",
    "confirmationByPhone": "Bel een specialist",
    "confirmationBooking100Percent1": "Je ontvangt binnen enkele minuten de bevestiging van je reis en die van je betaling.",
    "confirmationBooking100Percent2": "Ter herinnering, vandaag schrijven we",
    "confirmationBooking100Percent3": "af, wat overeenkomt met 100% van het bedrag van je reis.",
    "confirmationBooking100Percent4": "Je vindt al deze informatie op je Travelski-account. Je kunt",
    "confirmationBooking100Percent5": "hier",
    "confirmationBooking100Percent6": "inloggen.",
    "confirmationStatusReservationTitleAlreadyPaid": "Je verblijf is al betaald",
    "confirmationStatusErrorTitle": "Helaas, er is een fout opgetreden",
    "confirmationError1": "Helaas kan je boeking niet worden bevestigd. Probeer het later nogmaals of neem contact met ons op via",
    "confirmationOtherPaymentMethod": "020 8200 600",
    "confirmationReserveQuick": "Boek",
    "confirmationError1Sentence": "Helaas kon je boeking niet verwerkt worden",
    "confirmationUnavailableText": "Het gewenste verblijf is helaas niet meer beschikbaar. Probeer het opnieuw of neem contact met ons op via",
    "confirmationErrorText": "Helaas, je verblijf is niet meer beschikbaar. Probeer het opnieuw of neem contact met ons op via",
    "confirmationErrorPhone": "020 8200 600",
    "confirmationErrorPhoneYoonly": "+32 2 808 25 70",
    "confirmationMakeReservationAccountTitle": "Mijn account:",
    "confirmationMakeReservationAccount": "Log in op \"Mijn account\" om je boekinggegevens te vinden",
    "confirmationMakeReservationAccountButton": "Ga naar mijn account",
    "confirmationMakeReservationPhoneTitle": "Telefonisch",
    "confirmationMakeReservationPhone1": "Bel een van onze experts",
    "confirmationMakeReservationPhone2": "020 8200 600",
    "confirmationStatusUnavailableTitle": "Helaas, deze accommodatie is ofwel niet meer beschikbaar, of enkel te boeken in een pakket (met skipassen).",
    "confirmationStatusUnavailableSubtitle": "Excuses, de door jou geselecteerde accommodatie is niet langer beschikbaar.",
    "confirmationUnavailable1": "De door jou geselecteerde wintersport is niet langer beschikbaar omdat deze zojuist online door een ander is geboekt.",
    "confirmationUnavailable2": "Er zijn geen kosten in rekening gebracht.",
    "confirmationFindAnother": "Zoek een ander verblijf",
    "confirmationFindAnotherSameTitle": "Behoud dezelfde accommodatie",
    "confirmationFindAnotherSame1": "Is dit je favoriete accommodatie en ben je flexibel? Wijzig dan de data van je verblijf of kies een ander appartement / hotelkamer.",
    "confirmationFindAnotherSameButton": "Keer terug naar de accommodatie-pagina",
    "confirmationFindAnotherOtherTitle": "Verblijf in hetzelfde dorp en/of skigebied",
    "confirmationFindAnotherOther1": "Dit skigebied is erg populair, maar we weten zeker dat je een leuke reis zult vinden!",
    "confirmationFindAnotherOtherButton": "Onze andere accommodaties op",
    "confirmationFindAnotherSearchTitle": "Zoek opnieuw",
    "confirmationFindAnotherSearch1": "Wil je een andere accommodatie zoeken in dit dorp?",
    "confirmationFindAnotherSearch2": "Geen probleem, Travelski biedt verblijven 100+ skidorpen!",
    "confirmationFindAnotherSearchButton": "Zoek opnieuw",
    "confirmationFindAnotherQuestionTitle": "Heb je een vraag of opmerking?",
    "confirmationFindAnotherQuestion1": "020 8200 600",
    "confirmationYourOrder": "De door jouw gemaakte boeking",
    "confirmationSummaryDetailsButton": "Boekingsgegevens",
    "confirmationAccessAccount": "Ga naar mijn account",
    "confirmationEurostarTitle": "Haal je Eurostar-tickets op",
    "confirmationEurostarBody": "Je treintickets zijn beschikbaar op de Eurostar-website zodra je reizigersgegevens zijn ingevuld. Log in met je Eurostar-boekingsreferentie en achternaam, en vul de gevraagde informatie in om je e-tickets te openen.",
    "confirmationEurostarReference": "Eurostar-referentie:",
    "confirmationEurostarCta": "Mijn Eurostar-tickets ophalen",

    "confirmationQuote1": "Travelski bedankt u voor uw vertrouwen en bevestigt dat uw zoekopdracht succesvol is opgeslagen.",
    "confirmationQuote2": "Referentie:",
    "widgetCartSuccessTitle": "Uw treinbestelling is geregistreerd",
    "widgetSuccessTitle": "Reservering afgerond!",
    "widgetSuccessTicketsEmail": "Bedankt voor uw aankoop. U ontvangt binnen enkele minuten uw tickets op het e-mailadres:",
    "widgetCartSuccessInfo": "Uw bestelling is geregistreerd. U ontvangt uw tickets op het e-mailadres:",
    "widgetSuccessBackToSite": "Terug naar de site",
    "confirmationQuote3": "Een opgeslagen zoekopdracht is geen reservering. Alleen een aanbetaling of volledige betaling garandeert de beschikbaarheid van uw verblijf.",
    "confirmationStatusQuoteSubtitle": "Denk eraan uw reservering af te ronden.",
    "confirmationStatusQuoteTitle": "Uw zoekopdracht is opgeslagen"
  },
  "contacts": {
    "logInOrRegister": "Log in of registreer om te boeken",
    "loginRegister": "Inloggen / registreren",
    "login": "Inloggen",
    "emailNotValid": "Doorgaan",
    "errorWrongEmail": "Het ingevoerde e-mailadres is ongeldig. Controleer de gegevens en probeer opnieuw.",
    "contactsFirstName": "Voornaam",
    "contactsLastName": "Achternaam",
    "contactsEmail": "E-mail",
    "contactsOtherEmail": "Inloggen met een andere e-mail",
    "contactsPassword1": "Wachtwoord",
    "contactsPassword2": "Bevestig je wachtwoord",
    "contactsPasswordFormat": "Je wachtwoord moet",
    "contactsPasswordFormatLenght": "Minstens 8 tekens bevatten",
    "contactsPasswordFormatLowercase": "Minstens 1 kleine letter bevatten",
    "contactsPasswordFormatUppercase": "Minstens 1 hoofdletter bevatten",
    "contactsPasswordFormatNumber": "Minstens 1 cijfer bevatten",
    "contactsPasswordFormatCharacter": "minstens 1 speciaal teken bevatten (# ; @ ; $ ...)",
    "contactsPasswordsDontMatch": "Het wachtwoord komt niet overeen",
    "contactsEmailIsNotValid": "Het e-mailadres is niet geldig",
    "contactsAddress": "Adres",
    "contactsCity": "Stad",
    "contactsCountry": "Land",
    "contactsPostalCode": "Postcode",
    "contactsPhoneNumber": "00 00 00 00 00",
    "contactsSubscribeNewsletter": "Ik wil me graag abonneren op de Travelski.nl nieuwsbrief en profiteren van aanbiedingen!",
    "contactsAcceptConditions1": "Ik accepteer de",
    "contactsAcceptConditions2": "ANVR-reizigersvoorwaarden",
    "contactsAcceptConditions3": "&",
    "contactsAcceptConditions4": "Aanvullende Travelski.nl voorwaarden",
    "contactsIncorrectCredentials": "Jouw inloggegevens zijn onjuist",
    "registerCallCenterModalTitle": "Hulp nodig?",
    "registerCallCenterModalMessage": "Ons callcenter is bereikbaar tijdens de volgende openingstijden om je te helpen je boeking af te ronden.",
    "registerCallCenterModalPhone": "Telefoon",
    "registerCallCenterModalOpeningHours": "Openingstijden callcenter",
    "registerCallCenterModalCallButton": "Bel het callcenter"
  },
  "continue": {
    "continueWithTheseContacts": "Doorgaan met deze informatie",
    "continue": "Doorgaan"
  },
  "user": {
    "title": 'Coördinaten',
    "userInfoMandatoryField": "Verplicht veld",
    "userInfoInvalidPhone": "Ongeldig telefoonnummer formaat. Telefoonnummer moet 10 cijfers bevatten en beginnen met 0.",
    "userInfoInvalidPhoneLength": "Ongeldig formaat. Telefoonnummer moet 10 cijfers bevatten.",
    "userInfoForgotPassword": "Wachtwoord vergeten?",
    "userInfoAlreadyHaveAccount": "Heb je al een account?",
    "userInfoEnterEmail": "Klik hier om jouw wachtwoord aan te passen",
    "userInfoEmailSent": "Een link om je wachtwoord te resetten is verzonden naar",
    "userInfoNewPassword": "Voer je nieuwe wachtwoord in",
    "userInfoYourInformations": "Jouw gegevens",
    "userInfoEmail": "E-mail",
    "userInfoPhone": "Telefoon",
    "userInfoContactHint": "We gebruiken je contactgegevens om je boekingsdocumenten te sturen.",
    "userInfoToContactYou": "Mijn contactgegevens",
    "userInfoLiheMoreDetails": "Meer gegevens",
    "userInfoCreateAccount": "Maak een account aan",
    "userInfoIsItFirstTime": "Ga je voor het eerst op reis met Travelski?",
    "newPasswordForgotPassword": "Wachtwoord vergeten?",
    "newPasswordCreateNewPassword": "Maak je nieuwe wachtwoord",
    "newPassword1": "Nieuw wachtwoord",
    "newPassword2": "Bevestig je nieuwe wachtwoord",
    "invalidToken": "De token is verlopen. Probeer het opnieuw.",
    "newPasswordSucces": "Je wachtwoord is succesvol gewijzigd",
  },
  "sessionExpired": "Je sessie is bijna verlopen. Klik hier om door te gaan.",
  "paymentChanged": "De bedrag van je boeking is gewijzigd.<br>Je hebt niet worden belast.<br>Controleer je boeking en voer je creditcardgegevens opnieuw in.",
  "flightError": "Er is een fout opgetreden bij het boeken. Probeer het opnieuw."
}

export default commonNlTranslations;
